import { get, sync } from 'vuex-pathify'

export default {
	data() {
		return {
			config: this.$srv('AppBarConfig', {}),
			roundAppBarMenuLocation: this.$srv('AppBarConfig.roundAppBarMenuLocation', 'before'),
			logo: this.$srv('AppBarConfig.img'),
			logoMobile: this.$srv('AppBarConfig.imgMobile'),
			searchFieldType: this.$srv('SearchBarType.type', 'regular'),
			showMobileSearch: false,
			showMegaMenu: this.$srv('AppBarConfig.showMegaMenu', false),
			megaMenuType: this.$srv('AppBarConfig.megaMenuType', 'horizontal'),
			showHorizontalMegaMenu: this.$srv('AppBarConfig.showHorizontalMegaMenu', false),
		}
	},
	listen: {
		'shop-list:loaded'() {
			this.showMobileSearch = false
			this.menuMobileDrawer = false
		},
	},
	computed: {
		hideCartButton() {
			if (!this.$b.m) return false
			return (
				this.$srv('ActionBarMobile')?.items?.some((item) => {
					return item.type == 'cart'
				}) && this.$srv('ActionBarMobile.hideHeaderCartButton')
			)
		},
		megaMenuLocation() {
			return this.config.megaMenuLocation || 'bottom'
		},
		iconPosition() {
			return this.config.iconPosition || 'right'
		},
		appbarTransparent() {
			return this.config?.transparent || this.config?.type === 'transparent'
		},
		loading: get('shop/loading'),
		forceTransparency: get('shop/forceTransparency'),
		makeAppbarTransparent() {
			return this.isHomeRoute && !this.loading && this.appbarTransparent
		},
		isHomeRoute() {
			return this.$route.name === 'home'
		},
		user: get('shop/user'),
		loginLoading: get('shop/loginLoading'),
		menuMobileDrawer: sync('shop/menuMobileDrawer'),
		order: get('cart/order'),
		orderItemsQty() {
			return this.order?.items.reduce((sum, item) => {
				return sum + item.packQty + (item.children?.reduce((s, ci) => s + ci.packQty, 0) || 0)
			}, 0)
		},
		orderTotal() {
			return this.order?.total
		},
	},
	methods: {
		goToFavorites() {
			if (this.user) {
				this.$router.push({ name: 'user.favorites' })
			} else {
				this.showLoginDrawer()
			}
		},
		showCartDrawer() {
			this.$store.set('shop/cartDrawer', true)
		},

		showLoginDrawer() {
			this.$store.set('shop/loginDrawer', true)
		},
	},
	watch: {
		showMobileSearch(v) {
			const el = this.$refs.searchMobile
			if (v) {
				el.classList.remove('search-animation-leave')
				el.classList.add('search-animation-entry')
				el.querySelector('input').focus()
			} else {
				el.classList.remove('search-animation-entry')
				el.classList.add('search-animation-leave')
				el.querySelector('input').blur()
			}
		},
	},
}

